export default __webpack_public_path__ + "static/media/icon-cracked-screen-hand.d0097641.svg";